export class AvailableRepository {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integrationId",
            "baseName": "integrationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountLogin",
            "baseName": "accountLogin",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerRepositoryId",
            "baseName": "providerRepositoryId",
            "type": "string",
            "format": ""
        },
        {
            "name": "fullName",
            "baseName": "fullName",
            "type": "string",
            "format": ""
        },
        {
            "name": "_private",
            "baseName": "private",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "webUrl",
            "baseName": "webUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "defaultBranch",
            "baseName": "defaultBranch",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AvailableRepository.attributeTypeMap;
    }
    constructor() {
    }
}
